import React from "react";
import { IoIosTrash, IoIosWallet, IoIosAttach } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import { FormatNumber } from "../../helpers";

const MONTHS_ID = [
  "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
  "Jul", "Ags", "Sep", "Okt", "Nov", "Des",
];

function splitDate(d) {
  if (!d) return { day: "", month: "" };
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return { day: "", month: "" };
  return { day: String(dt.getDate()), month: MONTHS_ID[dt.getMonth()] };
}

export default function TransactionRow(props) {
  const { data, isFocused } = props;
  const isIncome = data.amount >= 0;
  const tags = data.tags || [];
  const { day, month } = splitDate(data.date);

  const edit = (e) => {
    if (e) e.stopPropagation();
    localStorage.setItem("cashflow", JSON.stringify(data));
    props.history.push("/transaction/edit/" + data.id);
  };

  const remove = (e) => {
    e.stopPropagation();
    if (props.onDelete) props.onDelete(data);
  };

  const searchByTag = (e, t) => {
    e.stopPropagation();
    localStorage.setItem("tag", JSON.stringify(t));
    props.history.push("/transaction-search");
  };

  return (
    <div
      id={`trx-card-${data.id}`}
      className={`trx-row trx-row--${isIncome ? "in" : "out"} ${
        isFocused ? "trx-row--focused" : ""
      }`}
      onClick={edit}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && edit()}
    >
      <div className="trx-row__date">
        <span className="trx-row__date-day">{day}</span>
        <span className="trx-row__date-month">{month}</span>
      </div>
      <div className="trx-row__desc">
        <div className="trx-row__desc-main">
          {data.attachmentUrl && (
            <span className="trx-card__attach" title="Ada lampiran">
              <IoIosAttach />
            </span>
          )}
          {data.description || (isIncome ? "Pemasukan" : "Pengeluaran")}
        </div>
        <div className="trx-row__desc-sub">
          <span className="trx-row__wallet">
            <IoIosWallet /> {data.wallet && data.wallet.name}
          </span>
          {tags.length > 0 && (
            <span className="trx-row__tags">
              {tags.map((t, i) => (
                <button
                  key={i}
                  type="button"
                  className="trx-tag trx-tag--mini"
                  onClick={(e) => searchByTag(e, t)}
                >
                  {t.tag}
                </button>
              ))}
            </span>
          )}
        </div>
      </div>
      <div
        className={`trx-row__amount trx-row__amount--${isIncome ? "in" : "out"}`}
      >
        {isIncome ? "+" : "−"}Rp{" "}
        {FormatNumber(Math.abs(Math.round(data.amount)))}
      </div>
      <div className="trx-row__actions">
        <button
          type="button"
          className="trx-row__action"
          title="Edit"
          aria-label="Edit"
          onClick={edit}
        >
          <FiEdit2 />
        </button>
        <button
          type="button"
          className="trx-row__action trx-row__action--danger"
          title="Hapus"
          aria-label="Hapus"
          onClick={remove}
        >
          <IoIosTrash />
        </button>
      </div>
    </div>
  );
}
